import Pulpmill from './pulpmill.js';

let Switcher = {
	switcherClear: function(){
        $("[data-switcher-list]").removeClass("active");
		$("[data-switcher-list-toggle]").removeClass("active");
    }
}

$(document).ready(function($) {
	$(".page").on("click",function(e){
		if (!($(e.target).data("switcher-list-toggle") || $(e.target).parents("[data-switcher-list]").data("switcher-list"))){
			Switcher.switcherClear();
		};
	})
	$(".page").on("click", "[data-switcher-list-toggle]", function(e){
		e.preventDefault();
		e.stopPropagation();

		Pulpmill.close();
		var list = $(this).siblings("[data-switcher-list]")[0];
		$(list).toggleClass("active");
		$(this).toggleClass("active");
	});

	$(".page").on("click", "[data-switcher-item]", function(){
		$(this).parents("[data-switcher-list]").siblings("[data-switcher-list-toggle]").text($(this).find("[data-switcher-link-lang]").text());
		$(this).parents("[data-switcher-list]").toggleClass("active");
		$(this).parents("[data-switcher-list]").siblings("[data-switcher-list-toggle]").toggleClass("active");
	});

});

export default {
  close: Switcher.switcherClear
};


// WEBPACK FOOTER //
// ./components/switcher.js